/**
 * @module ol/MapProperty
 */
/**
 * @enum {string}
 */
export default {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view',
};
//# sourceMappingURL=MapProperty.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/MapProperty.js
// module id = 380
// module chunks = 8